import { render, staticRenderFns } from "./architecMore.vue?vue&type=template&id=d7f0dcc8&scoped=true&"
import script from "./architecMore.vue?vue&type=script&lang=js&"
export * from "./architecMore.vue?vue&type=script&lang=js&"
import style0 from "./architecMore.vue?vue&type=style&index=0&id=d7f0dcc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f0dcc8",
  null
  
)

export default component.exports